import TDefaultLpLayout from './index.vue';

TDefaultLpLayout.install = app => {
  app.component(TDefaultLpLayout.name, TDefaultLpLayout);
};

export default TDefaultLpLayout;
